export const TRACKS = {
  mental_behavioral_health: {
    label: "Mental & Behavioral Health",
    short: "Health",
    badge: "bg-teal-500/15 text-teal-300 border-teal-500/30",
    badgeLight: "bg-teal-50 text-teal-800 border-teal-200",
    dot: "#14b8a6",
    icon: "HeartPulse",
  },
  corporate_hr_people_ops: {
    label: "Corporate & HR/People Ops",
    short: "Corporate",
    badge: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
    badgeLight: "bg-indigo-50 text-indigo-800 border-indigo-200",
    dot: "#6366f1",
    icon: "Briefcase",
  },
  nonprofits_education_community: {
    label: "Nonprofits, Education & Community",
    short: "Nonprofit",
    badge: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    badgeLight: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "#f59e0b",
    icon: "Users",
  },
  early_childhood_music: {
    label: "Daycares, Childcare & Preschools",
    short: "Childcare",
    badge: "bg-pink-500/15 text-pink-300 border-pink-500/30",
    badgeLight: "bg-pink-50 text-pink-800 border-pink-200",
    dot: "#ec4899",
    icon: "Music",
  },
};

export const STAGES = [
  { id: "sourced", label: "Sourced" },
  { id: "approved", label: "Approved" },
  { id: "submitted", label: "Submitted" },
  { id: "replied", label: "Replied" },
  { id: "booked", label: "Booked" },
  { id: "archived", label: "Archived" },
];

export const WEIGHTS = { relevance: 0.35, budget: 0.25, confidence: 0.2, logistics: 0.2 };

export function scoreColor(score) {
  if (score >= 80) return "text-emerald-400";
  if (score >= 60) return "text-amber-400";
  return "text-rose-400";
}

export function scoreBg(score) {
  if (score >= 80) return "bg-emerald-500";
  if (score >= 60) return "bg-amber-500";
  return "bg-rose-500";
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
